import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from './store/actions';

import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Modal } from 'office-ui-fabric-react/lib/Modal';

import Charts from './containers/Charts';
import About from './containers/About';
import Mapp from './containers/Map';
import Por from './containers/Por';
import Header from './components/Header';
import Instructions from './components/Instructions';
import { Dialog, DialogType, PrimaryButton, TextField, ActionButton } from 'office-ui-fabric-react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';

class App extends Component {
  state = {
    password: '',
    email: '',
    code: '',
    confirmPassword: '',
    login: true,
  };
  

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.auth.authorized !== this.props.auth.authorized){
      this.setState({password: '', email: '', code: '', confirmPassword: '', login: true})
    }
  }

  render() {
    if(!this.props.auth.authorized){
      return (
        <div className='auth'>
          <Dialog
            hidden={false}
            dialogContentProps={{
              type: DialogType.normal,
              title: this.state.login ? 'Sign in' : 'Register',
              subText: this.props.auth.loading && 'Checking authentication...'
            }}
            modalProps={{
              isBlocking: true,
              styles: { main: { maxWidth: 450 } }
            }}
          >
            { this.props.auth.message && <MessageBar onDismiss={() => this.props.authMessage(null)}>{this.props.auth.message}</MessageBar>}
            { this.props.auth.error && <MessageBar messageBarType={MessageBarType.error} onDismiss={() => this.props.authError(null)}>{this.props.auth.error}</MessageBar>}
            {
              this.state.login ? (
                <React.Fragment>
                  <TextField label='Email:' value={this.state.email} onChange={(e, email) => this.setState({email})} type='text'/>
                  <TextField label='Password:' value={this.state.password} onChange={(e, password) => this.setState({password})} type='password'/>
                  <div style={{padding: '12px 0px'}}>
                    <PrimaryButton style={{width: '100%'}} onClick={() => this.props.attemptAuth(this.state.email, this.state.password)} text="Sign in"/>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <TextField label='Email:' value={this.state.email} onChange={(e, email) => this.setState({email})} type='text'/>
                  <TextField label='Password:' value={this.state.password} onChange={(e, password) => this.setState({password})} type='password'/>
                  <TextField label='Confirm Password:' value={this.state.confirmPassword} onChange={(e, confirmPassword) => this.setState({confirmPassword})} type='password'/>
                  <TextField label='Access Code:' value={this.state.code} onChange={(e, code) => this.setState({code})} type='password'/>
                  <div style={{padding: '12px 0px'}}>
                    <PrimaryButton style={{width: '100%'}} onClick={() => this.props.attemptSignUp(this.state.email, this.state.password, this.state.confirmPassword, this.state.code)} text="Register" />
                  </div>
                </React.Fragment>
              )
            }
            <div style={{textAlign: 'center'}}>
              <ActionButton text={this.state.login ? 'Not registered? Sign up' : 'Already Registered? Sign in'} onClick={() => this.setState({login: !this.state.login})} />
            </div>
          </Dialog>
        </div>
      )
    }

    return (
      <Router>
        <div className='body'>
          <Modal
            isOpen={this.props.modal}
            onDismiss={ () => this.props.setModal(null) }
            isBlocking={false}
            className="modal"
          >
            <Instructions/>
          </Modal>
          <Header/>
          <div className="holygrail-body">
            <div className='content'>
              {
                this.props.filtersFetched && (
                  <Switch>
                    <Route path='/' exact component={ About }/>
                    <Route path='/map' exact component={ Mapp }/>
                    <Route path='/por' exact component={ Por }/>
                    <Route path='/charts/:method?/:source?/:river?/:type?/:locations?/:alternatives?/:pickYear?/:axisText?' component={ Charts }/>
                    <Redirect to='/' />
                  </Switch>
                )
              }
            </div>
          </div>
        </div>
      </Router>
    );
  }
};

const mapStateToProps = state => {
	return {
    modal: state.modal.modal,
    auth: state.auth,
    filtersFetched: state.multi.filtersFetched
	};
};

const mapDispatchToProps = dispatch => {
	return {
    setModal: (modal) => dispatch(actions.setModal(modal)),
    attemptAuth: (email, password) => dispatch(actions.attemptAuth(email, password)),
    attemptSignUp: (email, password, confirmPassword, code) => dispatch(actions.attemptSignUp(email, password, confirmPassword, code)),
    authError: (error) => dispatch(actions.authError(error)),
    authMessage: (message) => dispatch(actions.authMessage(message))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js